/**
 * Sunucu hata gövdesinden okunabilir mesajı çıkarır.
 *
 * SUNUCU İKİ FARKLI ALAN KULLANIYOR ve istemci yalnızca birini okuyordu.
 * Rotalar çoğunlukla `{ message }` dönüyor (477 yer), ara katmanlar ise
 * `{ error }` (172 yer) — ve `{ error }` dönenler tam da en çok açıklama
 * gereken yerler: `requireAuth`'un 401'leri ("Oturum süreniz doldu") ve
 * sahiplik/rol kontrollerinin 403'leri.
 *
 * Sonuç, koç panelinde şöyle görünüyordu: oturum süresi dolmuş bir koç
 * "Yeni Öğrenci Ekle" formunu doldurup kaydediyor, sunucu 401 + "Oturum
 * süreniz doldu, tekrar giriş yapın" diyor, istemci `data.message`
 * bulamayıp bunu atıyor ve ekranda "Öğrenci hesabı oluşturulamadı."
 * yazıyor. Gerçek sebep — yeniden giriş yapması gerektiği — kullanıcıya
 * HİÇ ULAŞMIYOR.
 *
 * Alanları sunucuda tek ada indirmek doğru olurdu ama 649 çağrı yerini
 * değiştirmek gerekirdi; okuma tarafını iki ada da dayanıklı yapmak aynı
 * sonucu tek yerde veriyor.
 *
 * `message` önce bakılıyor: rotaların kendi yazdığı mesaj, ara katmanın
 * genel mesajından daha özeldir.
 */
export const hataMesaji = (govde: unknown, yedek: string): string => {
    if (govde && typeof govde === 'object') {
        const k = govde as Record<string, unknown>;
        for (const alan of ['message', 'error'] as const) {
            const deger = k[alan];
            if (typeof deger === 'string' && deger.trim()) return deger.trim();
        }
    }
    return yedek;
};

/**
 * Token'ı geçersiz kılan kodlar — hepsi "yeniden giriş yapılmalı" demek.
 *
 * `TOKEN_EXPIRED` BURADA OLMADIĞI İÇİN süresi dolan oturum sessizce
 * ölüyordu: token 7 gün geçerli (`server/routes/auth.js`), süre dolunca
 * arayüz hâlâ giriş yapılmış GÖRÜNÜYOR, ama korumalı her istek 401
 * alıyor. Kullanıcı her ekranda başka bir "yapılamadı" mesajı görüyor ve
 * hiçbiri ona tekrar giriş yapmasını söylemiyor.
 */
export const OTURUM_BITTI_KODLARI = ['TOKEN_OUTDATED', 'TOKEN_EXPIRED', 'INVALID_TOKEN'] as const;

export const oturumBittiMi = (govde: unknown): boolean => {
    if (!govde || typeof govde !== 'object') return false;
    const kod = (govde as Record<string, unknown>).code;
    return typeof kod === 'string' && (OTURUM_BITTI_KODLARI as readonly string[]).includes(kod);
};
